import './HomePageLanding.css'; // Or a more generic Landing.css
import backgroundImage from '../img/dream_home.avif'; // Import your background image

const HomePageLanding = ({ title, description, children }) => {
  return (
    <div
      className="homepagelanding" 
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="content"> {/* Or a more generic landing-content */}
        <h1 className='main-text'>{title}</h1>
        <p className='sub-text '>{description}</p>
        {children} {/* This is where the call-to-action will be passed */}
      </div>
    </div>
  );
};

export default HomePageLanding;